var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { Actor } from '../../../classes/actor/Actor';
import { deserialize } from '../../../utils/serializr/serializr';
import { SortableItemPlace } from './modules/SortableItemPlace';
import { SortableItemEdit } from './modules/SortableItemEdit';
import { SortableItemState } from './modules/SortableItemState';
import { SortableItemUI } from './modules/SortableItemUI';
export class SortableItem extends Actor {
    type = 'sortableitem';
    droppableId = '';
    indexInDroppable = 0;
    isDragging = false;
    isDraggingDestinationIndex;
    isDraggingDestinationDroppableId = '';
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get itemIndex() {
        return this.question.sortableStore.sortableItems.indexOf(this);
    }
    get itemNumber() {
        return this.itemIndex + 1;
    }
    get currentSortableList() {
        return this.question.sortableLists.getListById(this.droppableId);
    }
    get itemPlace() {
        return new SortableItemPlace(this);
    }
    get itemEdit() {
        return new SortableItemEdit(this);
    }
    get itemState() {
        return new SortableItemState(this);
    }
    get itemUI() {
        return new SortableItemUI(this);
    }
    static fromSerialized(ser = {}) {
        return deserialize(SortableItem, ser);
    }
    static get serializeInfo() {
        return {
            extends: Actor.serializeInfo,
            props: {},
        };
    }
}
__decorate([
    observable
], SortableItem.prototype, "droppableId", void 0);
__decorate([
    observable
], SortableItem.prototype, "indexInDroppable", void 0);
__decorate([
    observable
], SortableItem.prototype, "isDragging", void 0);
__decorate([
    observable
], SortableItem.prototype, "isDraggingDestinationIndex", void 0);
__decorate([
    observable
], SortableItem.prototype, "isDraggingDestinationDroppableId", void 0);
__decorate([
    memoize
], SortableItem.prototype, "itemPlace", null);
__decorate([
    memoize
], SortableItem.prototype, "itemEdit", null);
__decorate([
    memoize
], SortableItem.prototype, "itemState", null);
__decorate([
    memoize
], SortableItem.prototype, "itemUI", null);
__decorate([
    memoize
], SortableItem, "serializeInfo", null);
